var _mask, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "email_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 16,
  x: 1.171,
  y: 4,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 16,
  x: 1.171,
  y: 4,
  stroke: "#9198A1",
  strokeWidth: 3,
  mask: "url(#email_svg__a)",
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9198A1",
  strokeWidth: 1.5,
  d: "m2.17 6 10 7 10-7M22.17 19l-8-7M2.17 19l8-7"
})));
SvgEmail.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export default ForwardRef;